import React, { useState, useEffect } from "react";
import HomePageNavBar from "../Components/HomePageNavBar";
import ListingsCard from "../Components/ListingsCard";
import { useNavigate, useLocation } from "react-router-dom";
import LocationNotFoundPopUp from "../Components/LocationNotFoundPopUp";
import {
  sortByTitleAZ,
  sortByTitleZA,
  sortLatestFirst,
  sortOldestFirst,
} from "../Services/helper";
import { useTranslation } from "react-i18next";
import Footer from "../Components/Footer";
import { getPreferredListings } from "../Services/listingsApi";
import { getCurrentUser } from "../Services/usersApi";

import LocationBarAllListings from "../Components/LocationBarAllListings";
import CITYDEFAULTIMAGE from "../assets/CityDefault.png";

const AllListings = () => {
  window.scrollTo(0, 0);
  const pageSize = window.innerWidth <= 768 ? 8 : 12;
  const { t } = useTranslation();
  const [selectedSortOption, setSelectedSortOption] = useState("");
  const [listings, setListings] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryId = searchParams.get("categoryId");
  const cityId = searchParams.get("cityId");
  const terminalViewParam = searchParams.get("terminalView");
  const [terminalView, setTerminalView] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [userLat, setUserLat] = useState(null);
  const [userLon, setUserLon] = useState(null);
  const [user, setUser] = useState(null);
  const [radius, setRadius] = useState(5000);
  const [locationPopup, setLocationPopup] = useState(null);
  const [locationSuccess, setLocationSuccess] = useState(null);
  const [success, setSuccess] = useState(null);
  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled =
    isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    document.title = process.env.REACT_APP_REGION_NAME;
    setTerminalView(isTerminalScreenEnabled);
    fetchData();
  }, [searchQuery, categoryId, cityId, pageNo]);

  const fetchData = async () => {
    try {
      let userId = window.localStorage.getItem("userId");

      setIsLoading(true);
      if (!userId) {
        try {
          const res = await getCurrentUser();
          if (res?.data?.id) {
            userId = res.data.id;
            localStorage.setItem("userId", userId);
          } else {
            console.warn("No user ID found in getCurrentUser response");
            setListings([]);
            return;
          }
        } catch (error) {
          console.error("Failed to fetch current user:", error);
          setListings([]);
          return;
        }
      }

      const params = {
        pageSize,
        statusId: 1,
        pageNo,
      };

      if (searchQuery.trim().length > 0) {
        params.searchQuery = searchQuery.trim();
      }

      if (userLat && userLon && radius) {
        params.lat = userLat;
        params.lon = userLon;
        params.radius = radius;
      }
      params.cityId = cityId || null;
      const response = await getPreferredListings(userId, params);
      let filteredListings = response.data?.data || [];

      if (categoryId) {
        filteredListings = filteredListings.filter(
          (listing) => listing?.categoryId?.toString() === categoryId
        );
      }

      if (cityId) {
        filteredListings = filteredListings.filter((listing) =>
          listing.cityData.some((city) => city?.id?.toString() === cityId)
        );
      }

      setListings(filteredListings);
    } catch (error) {
      console.error("Error fetching listings:", error);
      setListings([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    switch (selectedSortOption) {
      case "titleAZ":
        setListings([...sortByTitleAZ(listings)]);
        break;
      case "titleZA":
        setListings([...sortByTitleZA(listings)]);
        break;
      case "recent":
        setListings([...sortLatestFirst(listings)]);
        break;
      case "oldest":
        setListings([...sortOldestFirst(listings)]);
        break;
      default:
        break;
    }
  }, [selectedSortOption]);

  const onSearch = (term, lat = null, lon = null, rad = 5000) => {
    setSearchQuery(term);
    setUserLat(lat);
    setUserLon(lon);
    setRadius(rad);
  };
  async function handleSucess(value) {
    setSuccess(value);
    setTimeout(() => {
      setSuccess(null);
    }, 2000);
  }
  function goBack() {
    navigateTo(`/`);
  }

  return (
    <section className="text-gray-900 body-font relative">
      <HomePageNavBar user={user} setUser={setUser}/>
      {success && <div className="top-14 z-50 fixed right-2 p-3 bg-green-100 text-green-800 rounded-md text-xs">{success}</div>}
      {locationPopup&&<LocationNotFoundPopUp location={locationPopup} setIsOpen={setLocationPopup} handleSucess={handleSucess}/>}
      <div className="container-fluid py-0 mr-0 ml-0 mt-0 w-full flex flex-col relative">
        <div className="w-full mr-0 ml-0">
          <div className="h-[20rem] lg:h-full overflow-hidden px-0 py-0 relative">
            <div className="relative h-[20rem]">
              <img
                alt="ecommerce"
                className="object-cover object-center h-full w-full"
                src={CITYDEFAULTIMAGE}
                loading="lazy"
              />
              <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-800 bg-opacity-75 text-white z--1">
                <div className="w-full px-5 md:px-10 lg:px-[10rem] 2xl:px-[20rem] mx-auto flex justify-center">
                  <div className="w-full max-w-7xl">
                    <LocationBarAllListings
                      onSearch={onSearch}
                      searchQuery={searchQuery}
                      selectedSortOption={selectedSortOption}
                      onSortChange={setSelectedSortOption}
                      setLocationPopup={setLocationPopup}
                      refreshListings={fetchData}
                      terminalView={terminalView}
                      curretUser={user}
                      locationSuccess={locationSuccess}
                      setLocationSuccess={setLocationSuccess}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 mb-20 py-6">
        {isLoading ? (
          <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 space-y-10 flex flex-col">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
              {Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col space-y-4 rounded-lg border border-gray-200 p-4 animate-pulse"
                >
                  <div className="w-full h-48 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                  <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {listings && listings.length > 0 ? (
              <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 space-y-10 flex flex-col">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
                  {listings &&
                    listings.map((listing, index) => (
                      <ListingsCard
                        listing={listing}
                        terminalView={terminalViewParam}
                        key={index}
                      />
                    ))}
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center min-h-[40vh] px-6">
                <h2 className="mb-6 text-4xl font-bold">
                  {t("currently_no_listings")}
                </h2>
                <p className="text-lg text-gray-600">
                  {t("selectOtherCityorCategory")}
                </p>
                <button
                  onClick={goBack}
                  className="mt-10 px-6 py-3 bg-gray-700 text-white rounded-full hover:scale-105 transition"
                >
                  {t("goBack")}
                </button>
              </div>
            )}
          </>
        )}

        {listings.length > 0 && (
          <div
            className={`mt-20 mb-20 rounded-xl w-fit mx-auto 
      bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg
      hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out`}
          >
            {pageNo > 1 && (
              <span
                className="text-lg px-3 cursor-pointer"
                style={{
                  fontFamily:
                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                }}
                onClick={() => setPageNo(pageNo - 1)}
              >
                {"<"}
              </span>
            )}

            <span
              className="text-lg px-3"
              style={{
                fontFamily:
                  "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
              }}
            >
              {t("page")} {pageNo}
            </span>

            {/* If listings.length is equal to pageSize, it suggests there might be more pages */}
            {listings.length === pageSize && (
              <span
                className="text-lg px-3 cursor-pointer rounded-lg"
                style={{
                  fontFamily:
                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                }}
                onClick={() => setPageNo(pageNo + 1)}
              >
                {">"}
              </span>
            )}
          </div>
        )}
      </div>

      {!isLoading && !terminalView && (
        <div className="bottom-0 w-full">
          <Footer />
        </div>
      )}
    </section>
  );
};

export default AllListings;
